import clsx from 'clsx';
import { useTranslations } from 'next-intl';

import Address from '@/components/UI/Address';
import Contact from '@/components/UI/Contact';
import ContactOurTeam from '@/components/UI/ContactOurTeam';
import HomeSvg from '@/public/icon/home.svg';

interface EventPagePlaceSectionProps {
  place: any;
  contactEmail: string;
  className?: string;
}

export default function EventPagePlaceSection({
  place,
  contactEmail,
  className = '',
}: EventPagePlaceSectionProps) {
  const t = useTranslations('Pages.Event.EventPagePlaceSection');

  return (
    <section
      className={clsx(
        'space-y-6 pb-16 font-medium text-white-filled-default',
        className
      )}
    >
      <h3 className='my-6 text-xl font-extrabold'>{t('title')}</h3>
      <div className='flex items-center space-x-2'>
        <HomeSvg />
        <p>{place.name}</p>
      </div>
      <Address place={place} />
      <Contact email={contactEmail} />
      <ContactOurTeam />
    </section>
  );
}
